/// <reference types="./EventTypes.d.ts" />
export const EventType = {
    createPrincipal: 'createPrincipal',
    updateSchema: 'updateSchema',
    createEntity: 'createEntity',
    createAndPublishEntity: 'createAndPublishEntity',
    updateEntity: 'updateEntity',
    updateAndPublishEntity: 'updateAndPublishEntity',
    publishEntities: 'publishEntities',
    unpublishEntities: 'unpublishEntities',
    archiveEntity: 'archiveEntity',
    unarchiveEntity: 'unarchiveEntity',
    deleteEntities: 'deleteEntities',
};
//# sourceMappingURL=EventTypes.js.map